import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import './scss/Index.scss';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';

import App from './js/App';
import * as serviceWorker from './js/serviceWorker';
import { store, persistor } from './js/store/configureStore';
import { MyThemeProvider } from './ThemeContext';

const Root = document.getElementById('root');

if (Root) {
    ReactDOM.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <MyThemeProvider>
                    <App />
                </MyThemeProvider>
            </PersistGate>
        </Provider>,
        Root
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
